import React from 'react';
import { createPortal } from 'react-dom'; // 👈 引入 React Portal
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { X } from 'lucide-react';

export default function EnlargedImageModal({ src, onClose }) {
  if (!src) return null;

  // 这是模态框的实际内容，用原生 style 保证 100% 绝对铺满
  const modalContent = (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 99999,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(4px)',
      }}
      onClick={onClose}
    >
      {/* 绝对靠上的关闭按钮 */}
      <button
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          zIndex: 100000,
          backgroundColor: 'rgba(0,0,0,0.6)',
          borderRadius: '50%',
          padding: '8px',
          color: 'white',
          border: 'none',
          cursor: 'pointer'
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        <X size={32} />
      </button>

      {/* 拦截点击层，防止拖拽时关闭 */}
      <div 
        style={{ width: '100%', height: '100%' }}
        onClick={(e) => e.stopPropagation()}
      >
        <TransformWrapper
          initialScale={1}
          minScale={0.5}
          maxScale={4}
          centerOnInit={true}
          wheel={{ step: 0.1 }}
          doubleClick={{ disabled: true }}
        >
          <TransformComponent
            wrapperStyle={{ width: "100%", height: "100%" }}
            contentStyle={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <img
              src={src}
              alt="放大图片"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain', // 保证图片不变形且居中
                userSelect: 'none',
                WebkitUserDrag: 'none'
              }}
              draggable={false}
            />
          </TransformComponent>
        </TransformWrapper>
      </div>
    </div>
  );

  // 👈 核心：将弹窗直接传送到 <body> 标签下，物理隔绝任何父级 CSS 污染
  return createPortal(modalContent, document.body);
}